import { useRouter as useNextRouter } from 'next/router';
import { useMemo } from 'react';

import { matchPath } from '@kc-console/core';

import useServiceAppState from './useServiceAppState';
import useServiceMetaQuery from './useServiceMetaQuery';

/**
 * 서비스에서 next/router의 useRouter를 대체하는 훅
 * @description
 * baguni에서 useRouter를 통해 얻는 pathname과 query는 service개발 환경과 다릅니다.
 * 다른 값을 local 개발환경(MF 사용 X)과 배포환경(MF 사용 O)에서 같은 값을 얻기 위해 사용합니다.
 * MF를 사용하지 않을 때는 자기 서비스의 next config의 publicRuntimeConfig를 통해서 exposes Key를 얻습니다.
 * MF를 사용할 때는 manifest에서 exposes를 얻습니다.
 */

const useRouter = () => {
  const router = useNextRouter();
  const { query: originalQuery, asPath, ...other } = router;
  const { data: serviceMeta } = useServiceMetaQuery();
  const {
    state: { serviceKeyword },
  } = useServiceAppState();

  const routePaths = useMemo(
    () => serviceMeta?.routes?.map(route => `/${serviceKeyword}${route.path}`) || [],
    [serviceKeyword, serviceMeta?.routes],
  );

  const path = asPath.split('?')[0];

  const pathname = routePaths.find(routePath => matchPath(path, routePath)) || router.pathname;

  const query = { ...originalQuery };

  const splitPath = path.split('/');

  pathname?.split('/').forEach((v, i) => {
    if (v.startsWith('[') && v.endsWith(']')) {
      const match = v.match(/\[(.*?)\]/);

      const isMatchExist = match?.length === 2;

      if (isMatchExist) {
        // DESC: query['vpcId'] = 'uuid'
        query[match[1]] = splitPath[i];
      }
    }
  });

  return {
    ...other,
    asPath,
    pathname,
    query,
  };
};

export default useRouter;
